///<reference path="../../employee/sections/employee.serviceCommissions.section.ts"/>

module Meevo.Plugins.Teachers {
    'use strict';

    export class ServiceCommissionsSection extends Meevo.Plugins.Employee.ServiceCommissionsSection {

        get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.TeacherServiceCommissionOverride;
        }
    }
}